import React from 'react';
var context = /*#__PURE__*/React.createContext({
  offsetHeight: 0,
  scrollHeight: 0,
  setTarget: function setTarget() {
    return 0;
  },
  styleToClassName: function styleToClassName() {
    return '';
  }
});
context.displayName = 'ScrollToBottomInternalContext';
export default context;